export function getFromStorage(key, defaultValue = null) {
  try {
    const stored = localStorage.getItem(key)
    if (stored) return JSON.parse(stored)
  } catch { /* ignore parse errors */ }
  return defaultValue
}

export function saveToStorage(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch { /* ignore storage errors */ }
}
